import { request } from "common";
export function userInfo(params) {
  return request({
    url: "/portal/api/v1/user/detail",
    method: "get",
    params: params,
  });
}
/**获取当前用户身份信息 */
export function userIdentity(params) {
  return request({
    url: "/portal/api/v1/user/getUserIdentityInfo",
    method: "get",
    params: params,
  });
}
/**查询用户列表
 * @param {*} isAll 是否查询所有用户
 */
export function userData(queryParams, isAll = true) {
  let params = {};
  if (isAll) {
    params = { ...queryParams, ...{ pageSize: -1, pageNum: 1 } };
  }
  return request({
    url: "/portal/api/v1/user/list",
    method: "get",
    params: params,
  });
}

export function getUserByGroupName(params) {
  ///portal/api/v1/user/listuserGroup?groupName=董事会列席
  return request({
    url: "/portal/api/v1/user/listuserGroup",
    method: "get",
    params:params
  });
}

/*
* @description 用户组获取用户信息
* @param {*}  orgUuid
* @returns 
*/
export function getOrgAndNext(params) {
  return request({
    url: `/portal/api/v1/user/organdnext`,
    method: "get",
    params
  });
}

/**
 * @description 查询组织机构负责人
 * @param {*} data  ['11111', '222222']
 * @returns 
 */
export function queryLeaderByOrgUUids(data) {
  // /portal/api/v1/user/queryleader
  return request({
    url: `/portal/api/v1/user/queryleader`,
    method: "post",
    data,
  });
}

// 获取权限主题
export function permissionSubject(params) {
  return request({
    url: `/dmms-server/api/v1/user/getPermissionSubject`,
    method: "get",
    params
  });
}